import { Card, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const PageFooter = () => {
  return (
    <Card
      sx={{
        marginX: "auto",
        marginY: 2,
        display: "flex",
        justifyContent: "center",
        padding: 1,
        width: 250
      }}
    >
      <Typography variant="subtitle2">
        Made with 2 evo points by{" "}
        <Link to="https://twitter.com/East_ML">@EastML</Link>
      </Typography>
    </Card>
  );
};

export default PageFooter;
